import React from "react";
import "./PortFolioPreviewItem.scss";

export default function PortfolioPreviewItem({ modalId, image, alt, name, category, description, index, setActiveModal }) {
  return (
    <article className="project-card">
      <button type="button" className="project-card-button" onClick={() => setActiveModal(modalId)} aria-label={`View ${name} project details`}>
        <span className="project-image"><img src={`/img/portfolio/${image}`} alt={alt} loading="lazy" /><span className="project-image-action" aria-hidden="true">↗</span></span>
        <span className="project-meta"><span>{String(index).padStart(2, "0")} / {category}</span><span>VIEW PROJECT ↗</span></span>
        <span className="project-title">{name}</span>
        <span className="project-description">{description}</span>
      </button>
    </article>
  );
}
